import { all, call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { v4 as uuidv4 } from 'uuid';

import { AxiosCall, AxiosFile, AxiosPost } from "../../utils/axios";
import * as cartActions from '../shop/cart/actions';
import * as actions from './actions';
import { stopNotificationPoller } from '../messages/actions';


function* setInizialize(action) {
    try {
        let sessionId = localStorage.getItem('sessionId');
        if (!sessionId) {
            sessionId = uuidv4();
            localStorage.setItem('sessionId', sessionId);
        }
        yield put({ type: actions.INITIALIZE.SUCCESS, sessionId });
        yield put({ type: cartActions.FETCH_USER_CART.REQUEST, sessionId });



    } catch (e) {
        // Error handled silently
    }
}

function* resetSessionId(action) {
    try {

        const sessionId = uuidv4();
        localStorage.setItem('sessionId', sessionId);
        yield put({ type: actions.RESET_SESSION_ID.SUCCESS, sessionId });

    } catch (e) {
        // Error handled silently
    }
}

export function* setAddress({ payload: { recipient, phone, addressType, address, city, state, country, zipcode, isDefault } }) {
    try {

        const result = yield call(AxiosPost, `/user/add_address/`, { recipient, phone, addressType, address, city, state, country, zipcode, isDefault });
        yield put(actions.setAddressSuccess(result.data.results));
    } catch (e) {
        yield put(actions.setAddressFailure(e));
    }
}

export function* deleteAddress({ payload: { id } }) {
    try {
        const result = yield call(AxiosPost, `/user/delete_address/`, { id });
        yield put(actions.deleteAddressSuccess(result.data.results));
    } catch (e) {
        yield put(actions.deleteAddressFailure(e));
    }
} 



function* setUser(action) {
    try {
        const user = action.payload.user;
        yield put({ type: actions.SET_USER.SUCCESS, user });

    } catch (e) {
        // Error handled silently
    }
}

function* fetchSporeUser() {
    try {
        const result = yield call(AxiosCall, '/sporeuser/get_sporeuser_detail/');
        yield put(actions.fetchSporeUserSuccess(result.data.results.at(0)));
    } catch (e) {
        // Error handled silently
    }
}

function* fetchAddress() {
    try {
        const result = yield call(AxiosCall, '/user/get_addresses/');
        yield put(actions.fetchAddressSuccess(result.data.results));
    } catch (e) {
        // Error handled silently
    }
}

function* fetchSporeUserPerks() {
    try {
        const result = yield call(AxiosCall, '/sporeuser/get_sporeuser_perks/');
        yield put(actions.fetchSporeUserPerksSuccess(result.data.results));
    } catch (e) {
        // Error handled silently
    }
}

function* updateSporeUser(action) {
    try {
        const { name, country, city, shortDescription: short_description, fullDescription: full_description } = action.payload.data;
        const result = yield call(AxiosPost, '/sporeuser/update_sporeuser/', { name, country, city, short_description, full_description });
        yield put(actions.updateSporeUserSuccess(result.data.results.at(0)));
    } catch (e) {
        yield put(actions.updateSporeUserFailure(e.message));
    }
}


function* logout(action) {
    try {
        // Detener el notification poller al cerrar sesión
        yield put(stopNotificationPoller());

        yield put({ type: actions.LOGOUT.SUCCESS });

    } catch (e) {
        // Error handled silently
    }
}


function* updateTour(action) {
    try {
        const { name, value } = action.payload;
        const res = yield call(AxiosPost, '/user/update_tour/', { tour_name: name, to_update: value });

        if (res.status !== 200)
            throw new Error('error al establecer el tour');

        yield put({ type: actions.UPDATE_TOUR.SUCCESS, tour: res.data.results });
    } catch (e) {
        yield put({ type: actions.UPDATE_TOUR.FAILURE, message: e.message });
    }
}

function* addSporeUserImage(action) {
    try {
        const { image, location } = action.payload;
        const result = yield call(AxiosFile, '/sporeuser/post_sporeuser_image/', { image, location });
        yield put(actions.addSporeUserImageSuccess(result.data.results.at(0)));
    } catch (e) {
        yield put(actions.addSporeUserImageFailure(e.message));
    }
}

function* removeSporeUserImage(action) {
    try {
        const result = yield call(AxiosPost, '/sporeuser/delete_sporeuser_image/', { id: action.payload.id });
        yield put(actions.removeSporeUserImageSuccess(result.data.results.at(0)));
    } catch (e) {
        yield put(actions.removeSporeUserImageFailure(e.message));
    }
}

function* addSporeUserSpecialty(action) {
    try {
        const result = yield call(AxiosPost, '/sporeuser/add_specialty/', { specialty_slugs: [action.payload.specialty] });

        if (result.status !== 200)
            throw new Error('error al agregar la especialidad');

        yield call(fetchSporeUser);
        yield put(actions.addSporeUserSpecialtySuccess());
    } catch (e) {
        yield put(actions.addSporeUserSpecialtyFailure(e.message));
    }
}

function* addSporeUserSubSpecialty(action) {
    try {
        const result = yield call(AxiosPost, '/sporeuser/add_subspecialty/', { subspecialty_slugs: [action.payload.specialty] });

        if (result.status !== 200)
            throw new Error('error al agregar la especialidad');

        yield call(fetchSporeUser);
        yield put(actions.addSporeUserSpecialtySuccess());
    } catch (e) {
        yield put(actions.addSporeUserSpecialtyFailure(e.message));
    }
}

function* removeSporeUserSpecialty(action) {
    try {
        const result = yield call(AxiosPost, '/sporeuser/delete_specialty/', { specialty_slugs: [action.payload.id] });

        if (result.status !== 200)
            throw new Error('error al eliminar la especialidad');

        yield call(fetchSporeUser);
        yield put(actions.removeSporeUserSpecialtySuccess());
    } catch (e) {
        yield put(actions.removeSporeUserSpecialtyFailure(e.message || 'error al eliminar la especialidad'));
    }
}

function* removeSporeUserSubSpecialty(action) {
    try {
        const result = yield call(AxiosPost, '/sporeuser/delete_subspecialty/', { subspecialty_slugs: [action.payload.id] });

        if (result.status !== 200)
            throw new Error('error al eliminar la especialidad');

        yield call(fetchSporeUser);
        yield put(actions.removeSporeUserSpecialtySuccess());
    } catch (e) {
        yield put(actions.removeSporeUserSpecialtyFailure(e.message || 'error al eliminar la especialidad'));
    }
}

function* updateSporeUserSocial(action) {
    try {
        const result = yield call(AxiosPost, '/sporeuser/update_socials/', action.payload.socials);

        if (result.status !== 200)
            throw new Error('error al actualizar');

        yield put(actions.updateSporeUserSocialRequestSuccess(result.data.results));
    } catch (e) {
        yield put(actions.updateSporeUserSocialRequestFailure(e.message || 'error al actualizar'));
    }
}


function* updateSporeUserPassword(action) {
    try {
        const result = yield call(AxiosPost, '/user/reset_password_already_logged/', { password: action.payload.password });

        if (result.status !== 200)
            throw new Error('error al actualizar');

        yield put(actions.updateSporeUserPasswordSuccess());
    } catch (e) {
        yield put(actions.updateSporeUserPasswordFailure(e.message || 'error al actualizar'));
    }
}

function* clearSporeUserStatus() {
    yield put(actions.clearSporeUserStatusSuccess());
}



export default function* rootSaga() {
    yield all([
        // watchers sporeusers
        takeEvery(actions.INITIALIZE.REQUEST, setInizialize),
        takeEvery(actions.RESET_SESSION_ID.REQUEST, resetSessionId),
        takeEvery(actions.SET_USER.REQUEST, setUser),
        takeEvery(actions.LOGOUT.REQUEST, logout),
        // fetch sporeuser
        takeEvery(actions.FETCH_SPOREUSER.REQUEST, fetchSporeUser),
        // fetch user addresses
        takeEvery(actions.FETCH_ADDRESSES.REQUEST, fetchAddress),
        // fetch perks of sporeuser
        takeEvery(actions.FETCH_SPOREUSER_PERKS.REQUEST, fetchSporeUserPerks),
        // tour
        takeEvery(actions.UPDATE_TOUR.REQUEST, updateTour),
        // update
        takeEvery(actions.UPDATE_SPOREUSER.REQUEST, updateSporeUser),
        // image
        takeLatest(actions.ADD_SPOREUSER_IMAGE.REQUEST, addSporeUserImage),
        takeLatest(actions.REMOVE_SPOREUSER_IMAGE.REQUEST, removeSporeUserImage),
        // specialty
        takeLatest(actions.ADD_SPOREUSER_SPECIALTY.REQUEST, addSporeUserSpecialty),
        takeLatest(actions.REMOVE_SPOREUSER_SPECIALTY.REQUEST, removeSporeUserSpecialty),
        // subspecialty
        takeLatest(actions.ADD_SPOREUSER_SUBSPECIALTY.REQUEST, addSporeUserSubSpecialty),
        takeLatest(actions.REMOVE_SPOREUSER_SUBSPECIALTY.REQUEST, removeSporeUserSubSpecialty),
        // social
        takeLatest(actions.UPDATE_SPOREUSER_SOCIAL.REQUEST, updateSporeUserSocial),
        // password
        takeLatest(actions.UPDATE_SPOREUSER_PASSWORD.REQUEST, updateSporeUserPassword),
        // clears
        takeLatest(actions.CLEAR_SPOREUSER_STATUS.REQUEST, clearSporeUserStatus),
        // addresses
        takeLatest(actions.SET_USER_ADDRESS.REQUEST, setAddress),
        takeLatest(actions.DELETE_USER_ADDRESS.REQUEST, deleteAddress),

    ])
}
